<template>
<!-- Start breadcrumb section -->
<div class="inner-banner breadcrumb-area-info main-banner" :style="bannerStyle">
    <div class="image-layer" :style="{ backgroundImage: 'url(' + bannerImage + ')' }"></div>
    <div class="container">
        <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="breadcrumb-content">
                    <div class="section-title white-2">
                        <h4>Access</h4>
                        <h1 class="mt-3">アクセス</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="faq-one__form-wrap faq-one__home-three faq-one" style="margin-top:30px;">
    <div class="container">
      <div class="row breadcrumb-area-map">
          <div class="col-lg-12 d-flex">
              <div class="my-auto">
                  <div class="block-title text-left text-phone-center" data-aos="fade-right" :data-aos-duration="500">
                      <p><span>Access</span></p>
                  </div>
                  <div class="accrodion-grp" data-grp-name="career-one__accrodion">
                      <!-- 所在地 -->
                      <div class="accrodion" data-aos="fade-right" :data-aos-duration="500">
                          <div class="accrodion-title"><h4 id="address_1">所在地</h4></div>
                          <div class="accrodion-content">
                              <div class="inner">
                                  <p>〒{{HomeInfo.PostCode}} {{HomeInfo.Address}} {{ HomeInfo.Building }}</p>
                              </div>
                          </div>
                      </div>
                      <!-- FIX 3: アクセス方法 – 管理画面から取得した AccessGuide を使用 -->
                      <div class="accrodion" data-aos="fade-right" :data-aos-duration="500">
                          <div class="accrodion-title"><h4 id="car_1">アクセス方法</h4></div>
                          <div class="accrodion-content">
                              <div class="inner">
                                  <p v-if="HomeInfo.AccessGuide">
                                      <template v-for="(line, i) in accessLines" :key="i">
                                          {{ line }}<br v-if="i < accessLines.length - 1"/>
                                      </template>
                                  </p>
                                  <p v-else class="text-muted">アクセス情報は準備中です。</p>
                              </div>
                          </div>
                      </div>
                      <!-- 代表電話 -->
                      <div class="accrodion" data-aos="fade-right" :data-aos-duration="500">
                          <div class="accrodion-title"><h4 id="tel_1">代表電話</h4></div>
                          <div class="accrodion-content">
                              <div class="inner">
                                  <p><a :href="'tel:'+HomeInfo.Tel">{{HomeInfo.Tel}}</a><br/><br/><br/></p>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
</section>

<!-- FIX 3: 地図 – MapUrl は管理画面から取得済み -->
<section class="contact-map__block">
    <div class="container">
        <div class="block-title text-center" data-aos="fade-right" :data-aos-duration="500">
            <p><span> Map </span></p>
            <h3>醫健泰の所在地</h3>
        </div>
        <iframe
          v-if="HomeInfo.MapUrl"
          :src="HomeInfo.MapUrl"
          class="google-map__contact-page"
          allowfullscreen
          data-aos="fade-right"
          :data-aos-duration="500">
        </iframe>
        <div v-else class="yikt-map-placeholder" data-aos="fade-right" :data-aos-duration="500">
            <p class="text-muted">地図情報は準備中です。管理画面から設定してください。</p>
        </div>
    </div>
</section>
</template>

<script>
export default {
  name: "Access",
  computed: {
    bannerImage() {
      const v = this.HomeInfo && this.HomeInfo.Images && this.HomeInfo.Images.banner_access;
      return (!v || v === '/assets/images/shape/shape-25.png') ? '/assets/images/background/banner-image-1P.png' : v;
    },
    bannerStyle() {
      return {
        backgroundImage: `linear-gradient(rgba(0, 25, 65, .22), rgba(0, 25, 65, .22)), url(${this.bannerImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      };
    },
    // FIX 3: split AccessGuide by newlines for line-by-line rendering
    accessLines() {
      const guide = this.HomeInfo && this.HomeInfo.AccessGuide;
      if (!guide) return [];
      return guide.split(/\r?\n/).filter(l => l.trim() !== '');
    }
  }
}
</script>

<style scoped>
.yikt-map-placeholder {
  height: 300px; display: flex; align-items: center; justify-content: center;
  background: #f5f7fb; border-radius: 12px; border: 2px dashed #d1dce8;
}
</style>
